"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LargeIconQuotes = function LargeIconQuotes(_ref) {
  var activeTheme = _ref.activeTheme,
      inactiveTheme = _ref.inactiveTheme,
      active = _ref.active;
  var theme = active ? {
    primary: activeTheme[500],
    secondary: activeTheme[200]
  } : {
    primary: inactiveTheme[200],
    secondary: inactiveTheme[100]
  };
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "58",
    height: "57",
    fill: "none",
    viewBox: "0 0 58 57"
  }, /*#__PURE__*/_react.default.createElement("path", {
    stroke: theme.primary,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M15.807 1H41.465V42.321H15.807z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: theme.secondary,
    stroke: theme.primary,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M9.727 14.977L1 18.613l6.545 20.364 2.182-.728V14.977zM49.727 55.703L57 34.612l-9.455-3.636V48.43h-13.09l-.728 2.182 16 5.09z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: theme.primary,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M37.364 7.429H19.909M37.364 13.255H19.909M37.364 19.15H19.909M32.273 26.821A5.09 5.09 0 1033 36.302M31.545 30.248h-7.272M30.09 33.154h-5.817"
  }));
};

LargeIconQuotes.propTypes = {
  activeTheme: _propTypes.object,
  inactiveTheme: _propTypes.object,
  active: _propTypes.bool
};
var _default = LargeIconQuotes;
exports.default = _default;